import { defineStore } from 'pinia';
import { GameLotteryListType, GameTypeListType, TopClickListType } from 'types/game';
import casino from 'service/casino';
import HiCache from 'utils/cache';
import { useAppStore } from 'store/modules/appStore';

interface GameStoreStateType {
    gameLotteryList: GameLotteryListType[];
    gameTypeList: GameTypeListType[];
    topClickList: TopClickListType[];
    homeLoading: boolean;
}

export const useGameStore = defineStore('game', {
    state: (): GameStoreStateType => {
        return {
            gameLotteryList: [],
            gameTypeList: [],
            topClickList: [],
            homeLoading: true,
        };
    },
    getters: {
        getGameLotteryList: (state: GameStoreStateType) => state.gameLotteryList,
        getGameTypeList: (state: GameStoreStateType) => state.gameTypeList,
        getTopClickList: (state: GameStoreStateType) => state.topClickList,
        GetHomeLoading: (state: GameStoreStateType) => state.homeLoading,
    },
    actions: {
        async handleGetGame() {
            try {
                const response = await casino.getAllGames();
                if (response && response.code == 0) {
                    localStorage.setItem('gameLotteryList', JSON.stringify(response.data?.gameList));
                    this.gameLotteryList = response.data?.gameList;

                    const list = response.data?.typeList;
                    for (let i = 0; i < list.length; i++) {
                        const item = list[i];
                        if (item.valueList == null) {
                            this.gameLotteryList?.forEach(element => {
                                if (element?.game != null) {
                                    element?.game?.forEach(game => {
                                        item.game ??= [];
                                        item.game?.push(game);
                                    });
                                }
                            });
                        } else {
                            this.gameLotteryList?.forEach(element => {
                                if (item?.valueList?.includes(element?.value + '')) {
                                    if (element?.game != null) {
                                        element?.game?.forEach(game => {
                                            item.game ??= [];
                                            item.game?.push(game);
                                        });
                                    }
                                }
                            });
                        }
                    }

                    this.gameTypeList = list;

                    // iOS Safari localStorage 兼容性处理
                    const gameTypeListJson = JSON.stringify(this.gameTypeList);
                    console.log('💾 准备存储gameTypeList数据，大小:', gameTypeListJson.length, '字节');
                    console.log('📋 gameTypeList内容预览 - 数组长度:', this.gameTypeList.length, ', 第一项:', this.gameTypeList[0]);

                    let storageSuccess = false;
                    try {
                        localStorage.setItem('gameTypeList', gameTypeListJson);
                        console.log('✅ gameTypeList存储到localStorage成功');
                        storageSuccess = true;
                    } catch (error) {
                        console.warn('❌ localStorage存储失败，尝试sessionStorage降级:', error);
                        try {
                            sessionStorage.setItem('gameTypeList', gameTypeListJson);
                            console.log('✅ gameTypeList存储到sessionStorage成功');
                            storageSuccess = true;
                        } catch (sessionError) {
                            console.warn('❌ sessionStorage存储失败:', sessionError);
                            console.log('⚠️ gameTypeList仅存储在内存中，页面刷新后将丢失');
                        }
                    }

                    console.log(this.gameTypeList, '-----this.gameTypeList');
                    if (Array.isArray(response.data?.topClickList) && response.data?.topClickList?.length > 0) {
                        this.topClickList = response.data?.topClickList.filter(i => Number(i.value) === 110);

                        localStorage.setItem('topClickList', JSON.stringify(this.topClickList));
                    } else {
                        localStorage.setItem('topClickList', JSON.stringify([]));
                    }
                    return response.data;
                } else {
                    return [];
                }
            } catch (e) {}
        },
        // 获取游戏列表
        async handleGetAllGames() {
            try {
                this.homeLoading = true;
                const appStore = useAppStore();
                const res = await appStore.getGameVersion();
                // iOS Safari 兼容性：检查所有必需的缓存数据是否存在
              let hasGameLotteryList = false;
              let hasGameTypeList = false;

              try {
                  const gameLotteryListData = localStorage.getItem('gameLotteryList');
                  const gameTypeListDataLocal = localStorage.getItem('gameTypeList');
                  const gameTypeListDataSession = sessionStorage.getItem('gameTypeList');

                  console.log('🔍 iOS Safari缓存检查详情:');
                  console.log('gameLotteryList localStorage:', gameLotteryListData ? `存在(${gameLotteryListData.length}字节)` : '不存在');
                  console.log('gameTypeList localStorage:', gameTypeListDataLocal ? `存在(${gameTypeListDataLocal.length}字节)` : '不存在');
                  console.log('gameTypeList sessionStorage:', gameTypeListDataSession ? `存在(${gameTypeListDataSession.length}字节)` : '不存在');
                  console.log('GameVersionKey:', HiCache.getCache('GameVersionKey'));
                  console.log('当前版本:', res);

                  hasGameLotteryList = !!gameLotteryListData;
                  hasGameTypeList = !!(gameTypeListDataLocal || gameTypeListDataSession);
              } catch (error) {
                  console.warn('检查缓存数据失败:', error);
              }

              if (hasGameLotteryList && hasGameTypeList && HiCache.getCache('GameVersionKey')) {
                    let ConfigVersionKey1 = HiCache.getCache('GameVersionKey');
                    if (Number(ConfigVersionKey1) === Number(res)) {
                        // iOS Safari 兼容性读取：先尝试localStorage，再尝试sessionStorage
                      let gameTypeListData: string | null = null;
                      let dataSource = '无';

                      try {
                          gameTypeListData = localStorage.getItem('gameTypeList');
                          if (gameTypeListData) {
                              dataSource = 'localStorage';
                              console.log('✅ 从localStorage读取gameTypeList成功，数据大小:', gameTypeListData.length, '字节');
                          }
                      } catch (error) {
                          console.warn('❌ localStorage读取gameTypeList失败:', error);
                      }

                      if (!gameTypeListData) {
                          try {
                              gameTypeListData = sessionStorage.getItem('gameTypeList');
                              if (gameTypeListData) {
                                  dataSource = 'sessionStorage';
                                  console.log('✅ 从sessionStorage读取gameTypeList成功，数据大小:', gameTypeListData.length, '字节');
                              }
                          } catch (error) {
                              console.warn('❌ sessionStorage读取gameTypeList失败:', error);
                          }
                      }

                      if (gameTypeListData) {
                          try {
                              this.gameTypeList = JSON.parse(gameTypeListData);
                              console.log(`📊 gameTypeList解析成功 - 数据源: ${dataSource}, 数组长度: ${this.gameTypeList.length}, 第一项:`, this.gameTypeList[0]);
                          } catch (parseError) {
                              console.error('❌ gameTypeList JSON解析失败:', parseError);
                              this.gameTypeList = [];
                          }
                      } else {
                          console.log('❌ 未找到gameTypeList缓存数据');
                          this.gameTypeList = [];
                      }

                      const gameLotteryListData = localStorage.getItem('gameLotteryList');
                      if (gameLotteryListData) {
                          try {
                              this.gameLotteryList = JSON.parse(gameLotteryListData);
                              console.log(`📊 gameLotteryList解析成功 - 数组长度: ${this.gameLotteryList.length}, 第一项:`, this.gameLotteryList[0]);
                          } catch (parseError) {
                              console.error('❌ gameLotteryList JSON解析失败:', parseError);
                              this.gameLotteryList = [];
                          }
                      } else {
                          console.log('❌ 未找到gameLotteryList缓存数据');
                          this.gameLotteryList = [];
                      }

                      this.topClickList = JSON.parse(localStorage.getItem('topClickList') || '[]') || [];

                      // iOS Safari 兼容性：如果读取的数据为空，强制重新请求
                      console.log('🔍 数据完整性检查 - gameTypeList长度:', this.gameTypeList.length, 'gameLotteryList长度:', this.gameLotteryList.length);
                      if (this.gameTypeList.length === 0 || this.gameLotteryList.length === 0) {
                          console.warn('⚠️ iOS Safari缓存数据不完整，强制重新请求游戏数据');
                          try {
                              await this.handleGetGame();
                              HiCache.setCache('GameVersionKey', res);
                              console.log('✅ 重新请求游戏数据成功');
                          } catch (e) {
                              console.error('❌ 重新请求游戏数据失败:', e);
                              this.gameTypeList = [];
                              this.gameLotteryList = [];
                              this.topClickList = [];
                          }
                      } else {
                          console.log('✅ 缓存数据完整，使用缓存数据');
                      }

                        this.homeLoading = false;
                    } else {
                        try {
                            await this.handleGetGame();
                            HiCache.setCache('GameVersionKey', res);
                            this.homeLoading = false;
                        } catch (e) {
                            this.gameTypeList = [];
                            this.gameLotteryList = [];
                            this.topClickList = [];
                        }
                    }
                } else {
                    try {
                        await this.handleGetGame();
                        HiCache.setCache('GameVersionKey', res);
                        this.homeLoading = false;
                    } catch (e) {
                        this.gameTypeList = [];
                        this.gameLotteryList = [];
                        this.topClickList = [];
                    }
                }
            } catch (e) {
                this.gameTypeList = [];
                this.gameLotteryList = [];
                this.topClickList = [];
            }
        },

        //切换游戏列表
        setGameList(item, isUnmounted) {
            if (isUnmounted) {
                this.gameLotteryList = item;
            } else {
                if (item?.valueList) {
                    //过滤游戏列表数据
                    let gameLotteryListLocal = localStorage.getItem('gameLotteryList') || '';
                    this.gameLotteryList = JSON.parse(gameLotteryListLocal).filter(i => item?.valueList.indexOf(i?.value + '') !== -1);
                    // console.log(this.gameLotteryList, 'this.gameLotteryList');
                } else {
                    let gameLotteryListLocal = localStorage.getItem('gameLotteryList') || '';
                    this.gameLotteryList = JSON.parse(gameLotteryListLocal);
                }
            }
        },
    },
});
